export const COLOR_CHANGE = 'COLOR_CHANGE'
export const COLOR_CHANGE_SUCCESS = 'COLOR_CHANGE_SUCCESS'
export const COLOR_CHANGE_FAILURE = 'COLOR_CHANGE_FAILURE'
export const COLOR_CHANGE_FORCE = 'COLOR_CHANGE_FORCE'